import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function PrivateTripCard({ trip, index = 0 }) {
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.8, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`private-trip-card-${trip.id}`}
    >
      <Link to={`/private-trips/${trip.id}`} className="group block">
        <div className="relative aspect-[4/5] overflow-hidden bg-owt-sand">
          <motion.img
            src={trip.hero_image}
            alt={trip.name}
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            className="w-full h-full object-cover"
            whileHover={{ scale: 1.06 }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-owt-ink/70 via-transparent to-transparent"/>
          <div className="absolute top-4 left-4 right-4 flex items-start justify-between">
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-owt-surface bg-owt-forest/70 backdrop-blur px-2 py-1">
              {trip.country}
            </span>
            <span className="stamp bg-owt-surface/95 text-owt-terracotta !border-owt-terracotta">Private</span>
          </div>
          <div className="absolute bottom-4 left-4 right-4 text-owt-surface">
            <div className="font-display text-2xl md:text-3xl leading-tight">{trip.name}</div>
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase opacity-80 mt-1">
              {trip.duration_days} days · designed around you
            </div>
          </div>
        </div>
        <div className="mt-3 flex items-center justify-between">
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-owt-muted">{trip.destination}</div>
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-owt-terracotta inline-flex items-center gap-1">Enquire <ArrowUpRight className="w-3 h-3"/></div>
        </div>
      </Link>
    </motion.div>
  );
}
